module.exports = __webpack_public_path__ + "img/Article4A.260026cd.jpeg";